module.exports = __webpack_public_path__ + "img/U-Save.061a5f40.gif";